export enum ReportListEnum {
    // Main Reports
    OkkComplaintsOnCommission,
    FeedbackIndexes,
    ForPeriodOffences,
    ForOkkProcessedComplaints,
    ForCountOkkComplaints,
    ForPeriodPreOrderCancels,
    ForPeriodRating,
    ForPeriodMobile,
    TradePointCheckLists,
    CompletedQCCheckLists,
    StatusLog,
    DiscrepancyIndexExcel,
    GeneralViolations,
    ForOkkGuestCommunication,
    HrStaffLevels,

    // Learning Reports
    AssignedLessonsResultEmployee,
    GradeLessonsResultEmployee,
    TradePointsUsersGrades,
    TradePointsRolesGrades,
    LessonsResultOfficeWorkers,
    LessonPollsResult,
    AdminsUsersGrades,
    GradeTreeLessons,
    ConsultationSurvey,
    InternshipSurvey,
    StudentEventsSurvey,
    UsersGrades,
    ManagersWithoutGrade,
    ArticleUnreadUsers,
    // Employees Reports
    DocumentMedicalBookReport,
    DocumentUser,
    //clients
    ClientsBonus,
    ClientsCategory,
    //operational reports
    OperationalTradePointSummary,
    OperationalSalePlan,
    // SD Reports
    SdReport,
}
